import { decodeUrl } from "../../helperFunctions";
import { SingleUser } from "../../redux/features/auth/auth.type";

export const MemberProfilePic = ({
  member,
  className,
}: {
  member?: SingleUser;
  className?: string;
}) => {
  const colors = ["!bg-[#F1D7FD] !border-[#F1D7FD]"];

  const randomColor = colors[Math.floor(Math.random() * colors.length)];

  return (
    <div
      className={`
        w-[72px] h-[72px] flex items-center justify-center
        ${!member?.Picture && `text-[16px] font-bold uppercase ${randomColor}`}
        rounded-full overflow-hidden border object-cover ${className}
        `}
    >
      {member?.Picture ? (
        <img
          src={decodeUrl(member?.Picture)}
          alt="member_Picture"
          className="object-cover w-full h-full"
        />
      ) : (
        `${member?.FirstName?.slice(0, 1)}${member?.LastName?.slice(0, 1)}`
      )}
    </div>
  );
};
